/**
 * Returns Device type
 */
export default function useDeviceOs() {
    const isIphone = computed(() => {
        const u = navigator.userAgent;
        return !!u.match(/iPhone/i);
    });

    const isIpad = computed(() => {
        const u = navigator.userAgent;
        return !!u.match(/iPad/i);
    });

    const isMac = computed(() => {
        const u = navigator.userAgent;
        return !!u.match(/Mac OS/i);
    });

    const isAndroid = computed(() => {
        const u = navigator.userAgent;
        return !!u.match(/Android/i);
    });

    const isChrome = computed(() => {
        const u = navigator.userAgent;
        return !!u.match(/Chrome/i);
    });

    const isApple = computed(() => {
        return isIphone.value || isIpad.value || isMac.value;
    });

    return {
        isIphone,
        isAndroid,
        isIpad,
        isApple,
        isChrome,
    };
}
